import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./features/gmail/redux/store";

import App from "./App";

// Console easter egg
if (process.env.NODE_ENV === "production") {
  console.log(
    "%c Hey there! 👋",
    "color: #4285F4; font-size: 24px; font-weight: bold;"
  );
  console.log(
    "%c Curious about the code? Check it out: https://github.com/jasur-2902/shukurov",
    "color: #34A853; font-size: 14px;"
  );
}

const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </StrictMode>
);
